const ENTRY_TYPES = { expense: "expense", payment: "payment", income: "income" };

const entryTypeOf = (entry) => entry?.type ?? ENTRY_TYPES.expense;

const isIncomeType = (type) => type === ENTRY_TYPES.income;

const balanceSignOf = (type) => (isIncomeType(type) ? -1 : 1);

// Old apps open an income in their expense popup and save it as "expense".
const storedEntryType = (requestedType, storedType) =>
  requestedType === ENTRY_TYPES.expense && isIncomeType(storedType)
    ? ENTRY_TYPES.income
    : requestedType;

module.exports = {
  ENTRY_TYPES,
  entryTypeOf,
  isIncomeType,
  balanceSignOf,
  storedEntryType,
};
